import { z } from 'zod';

export const Target2SellConfigDTO = z.object({
    T2SPageSpace: z.string().nullish(),
});

export type Target2SellConfigDTO = z.infer<typeof Target2SellConfigDTO>;
